import { render, staticRenderFns } from "./tenseDetails.vue?vue&type=template&id=3d86e4f9&scoped=true&"
import script from "./tenseDetails.vue?vue&type=script&lang=js&"
export * from "./tenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./tenseDetails.vue?vue&type=style&index=0&id=3d86e4f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86e4f9",
  null
  
)

export default component.exports